import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-star-rating',
    templateUrl: './star-rating.component.html',
    standalone: true,
    imports: [
        CommonModule,
    ],
})
export class StarRatingComponent implements OnInit {

    @Input('rating') private rating: number = 5;
    @Input('starCount') private starCount: number = 5;
    @Output() public ratingUpdated = new EventEmitter();

    public ratingArr = [];

    constructor() {}

    ngOnInit() {
        for (let index = 0; index < this.starCount; index++) {
            this.ratingArr.push(index);
        }
    }

    onClick(rating: number) {
        this.rating = rating;
        this.ratingUpdated.emit(rating);
        return false;
    }

    showIcon(index: number) {
        if (this.rating >= index + 1) {
            return 'star';
        } else {
            return 'star_border';
        }
    }
}
